<template>
    <loader v-if="isLoading == true" name="spinning" loadingText="Cargando..." textColor="#ffffff" textSize="20" textWeight="500" object="#ff9633" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" :disableScrolling="true"></loader>
  
      <div class="container">
     
        <div class="row">
            <h3 style="text-align: left;">Estatus:</h3><br>
          <div class="col-md-12 row">
              
              <div class="col-md-1">
                  <button type="button" class="btn btn-danger">Rechazar</button>
              </div>
              <div class="col-md-1">
                <button type="button" class="btn btn-dark">Aprobar</button>
            </div><br>
              <h2 style="text-align: left;">Documentos</h2>
            
              <ul class="styled-list">
                <h3 style="text-align: left;">Legal</h3>
                <li class="list-item" v-for="form in arregloLegal" :key="form.id">
                  <template v-if="form.tipo == 'Legal'">
                    <span v-if="form.estatus == 'Pendiente'" class="circle"></span>
                    <span v-else class="circlecolor"></span>
                    {{ form.nombre }} <button v-if="form.url_pdf" @click="downloadPDF(form)" type="button" class="btn btn-warning btn-sm" ><span class="fa fa-download"></span> &nbsp; {{ form.url_pdf }}</button>&nbsp;
                    <button v-if="form.url_pdf" type="button" class="btn btn-danger btn-sm" @click="eliminarArchivo(form.id)"><span class="fa fa-trash"></span>&nbsp;Eliminar</button>
                  </template>
                </li>
                
                <h3 style="text-align: left;">Inspector</h3>
                <li class="list-item" v-for="form in arregloInspector" :key="form.id">
                  <template v-if="form.tipo == 'Inspector'">
                    <span v-if="form.estatus == 'Pendiente'" class="circle"></span>
                    <span v-else class="circlecolor"></span>
                    {{ form.nombre }} <button v-if="form.url_pdf" @click="downloadPDF(form)" type="button" class="btn btn-warning btn-sm" ><span class="fa fa-download"></span> &nbsp; {{ form.url_pdf }}</button>&nbsp;
                    <button v-if="form.url_pdf" type="button" class="btn btn-danger btn-sm" @click="eliminarArchivo(form.id)"><span class="fa fa-trash"></span>&nbsp;Eliminar</button>
                  </template>
                </li>
                <h3 style="text-align: left;">CRE</h3>
                <li class="list-item" v-for="form in arregloCRE" :key="form.id">
                  <template v-if="form.tipo == 'CRE'">
                    <span v-if="form.estatus == 'Pendiente'" class="circle"></span>
                    <span v-else class="circlecolor"></span>
                    {{ form.nombre }} <button v-if="form.url_pdf" @click="downloadPDF(form)" type="button" class="btn btn-warning btn-sm" ><span class="fa fa-download"></span> &nbsp; {{ form.url_pdf }}</button>&nbsp;
                    <button v-if="form.url_pdf" type="button" class="btn btn-danger btn-sm" @click="eliminarArchivo(form.id)"><span class="fa fa-trash"></span>&nbsp;Eliminar</button>
                  </template>
                </li>
                <h3 style="text-align: left;">Administrador</h3>
                <li class="list-item" v-for="form in arregloAdministrador" :key="form.id">
                  <template v-if="form.tipo == 'Administrador'">
                    <span v-if="form.estatus == 'Pendiente'" class="circle"></span>
                    <span v-else class="circlecolor"></span>
                    {{ form.nombre }}  <button v-if="form.url_pdf" @click="downloadPDF(form)" type="button" class="btn btn-warning btn-sm" ><span class="fa fa-download"></span> &nbsp; {{ form.url_pdf }}</button>&nbsp;
                    <button v-if="form.url_pdf" type="button" class="btn btn-danger btn-sm" @click="eliminarArchivo(form.id)"><span class="fa fa-trash"></span>&nbsp;Eliminar</button>
                  </template>
                </li>
              </ul>
           
             
                
              
             
        
          </div>
         <div style="text-align: left;">
          <button type="button" class=" btn btn-warning btn-sm" @click="pdflista()">Lista Inspección</button>

         </div>
         <br>
         <div style="text-align: left;">
          <br>
          <button type="button" class=" btn btn-warning btn-sm" @click="pdfPlan()">Plan Inspección</button>

         </div>
         <div style="text-align: left;">
          <br>
          <button type="button" class=" btn btn-warning btn-sm" @click="pdfActa()">Acta Inspección</button>

         </div>
          
        </div>
        <br>
       
        
  
      </div>
    </template>
    
    <script>
    import axios from 'axios';
    import Swal from 'sweetalert2';
    
    export default {
      data() {
        return {
          isLoading: false,
          datos: [],
          nombreOficio:'',
          formularios:[],
          arregloLegal:[],
          arregloInspector:[],
          arregloCRE:[],
          arregloAdministrador:[]
        }
      },
      mounted() {
        this.consultarFormulario();
      },
      created() {
        //this.consultarFormulario();
        this.fetchData();
        
      },
      methods: {
        pdfActa(){
          var idcotizacion = localStorage.getItem('idcotizacion');
    
          axios({
            method: 'post',
            url: this.$rutaServer + 'generatePdfActaInspeccion',
            responseType: 'blob', // Aquí es donde se especifica el tipo de respuesta
            data: { idcotizacion: idcotizacion } // Datos que envías al servidor
          })
          .then(response => {
        
          if (response.status === 200) {
            // Crear un objeto Blob a partir de la respuesta
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'actainspeccion.pdf'); // Nombre del archivo

            // Agregar y hacer clic en el enlace para iniciar la descarga
            document.body.appendChild(link);
            link.click();

            // Limpiar
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url); // Liberar la memoria utilizada por el objeto URL
        }
        })
        .catch(error => {
            Swal.fire('¡Error!', 'Ocurrió un error al generar el PDF', 'error');
            console.error('Error al descargar el PDF:', error);
        });
        },
        pdfPlan(){
          var idcotizacion = localStorage.getItem('idcotizacion');
    
          axios({
            method: 'post',
            url: this.$rutaServer + 'generatePdfPlanInspeccion',
            responseType: 'blob', // Aquí es donde se especifica el tipo de respuesta
            data: { idcotizacion: idcotizacion } // Datos que envías al servidor
          })
          .then(response => {
        
          if (response.status === 200) {
            // Crear un objeto Blob a partir de la respuesta
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'planinspeccion.pdf'); // Nombre del archivo

            // Agregar y hacer clic en el enlace para iniciar la descarga
            document.body.appendChild(link);
            link.click();

            // Limpiar
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url); // Liberar la memoria utilizada por el objeto URL
        }
        })
        .catch(error => {
            Swal.fire('¡Error!', 'Ocurrió un error al generar el PDF', 'error');
            console.error('Error al descargar el PDF:', error);
        });
        },
        pdflista() {
          var idcotizacion = localStorage.getItem('idcotizacion');
    
    axios({
        method: 'post',
        url: this.$rutaServer + 'generarPDFlistaInspeccion',
        responseType: 'blob', // Aquí es donde se especifica el tipo de respuesta
        data: { idcotizacion: idcotizacion } // Datos que envías al servidor
    })
    .then(response => {
        console.log(response);
        if (response.status === 200) {
            // Crear un objeto Blob a partir de la respuesta
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'lista_inspeccion.pdf'); // Nombre del archivo

            // Agregar y hacer clic en el enlace para iniciar la descarga
            document.body.appendChild(link);
            link.click();

            // Limpiar
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url); // Liberar la memoria utilizada por el objeto URL
        }
    })
    .catch(error => {
        Swal.fire('¡Error!', 'Ocurrió un error al generar el PDF', 'error');
        console.error('Error al descargar el PDF:', error);
    });
        },
       
        downloadPDF(ruta) {
          const pdfUrl = ruta.url;
          window.open(pdfUrl, '_blank');
        },
        eliminarArchivo(formId){
        
            axios.post(this.$rutaServer+'actualizarArchivosInspeccion',  { id: formId })
                    .then(response => {
                        if (response.status == 200) {
                            Swal.fire('¡Éxito!', 'Archivo eliminado', 'success');
                            this.formularios = [];
                            this.arregloLegal = [];
                            this.arregloInspector = [];
                            this.arregloCRE = [];
                            this.arregloAdministrador = []
                            this.consultarFormulario();
                        }
                    })
                    .catch(error => {
                       
                    });

          
    },
        async generatePDF() {
        try {
          const dateObj = new Date(this.datos.fecha);
          const day = dateObj.getDate().toString().padStart(2, '0');
          const month = dateObj.toLocaleString('es-ES', { month: 'long' });
          const year = dateObj.getFullYear();
          const formattedDate = `${day} de ${month} de ${year}`;
  
          var enviar = {
            idcotizacion : this.datos.id,
            folio: this.datos.folio,
            razon_social: this.datos.razon_social,
            direccion: this.datos.direccion,
            inspector: this.datos.inspector,
            tipo: this.datos.tipo,
            capacidad:this.datos.capacidad +''+this.datos.unidad,
            voltaje_conexion : this.datos.voltaje_conexion,
            importe: this.datos.importe,
            asignado:this.datos.usuario,
            fecha:formattedDate
          };
          const response = await axios.post('https://api.seigrupo.com.mx/api/generate-pdf',enviar, {
            responseType: 'blob' // Important for binary data
            
          });
  
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.datos.id+'.pdf'); // or any other extension
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } catch (error) {
          console.error('Error generating PDF:', error);
        }
      },
          regresar(){
          this.$router.push('/cotizacion');
          },
        fetchData() {
          var id = localStorage.getItem('idcotizacion');
          axios.post(this.$rutaServer+'datosCotizacion', { id: id })
            .then(response => {
              if (response.status == 200) {
                this.datos = response.data.data[0];
                if(this.datos.oficio_cfe){
                  var arreglo = this.datos.oficio_cfe.split('/');
                  this.nombreOficio = arreglo[2];
                }
                
                
                console.log(this.datos);
              }
            })
            .catch(error => {
              Swal.fire('¡Error!', 'Ocurrió un error', 'error');
            });
        },
        consultarFormulario() {
          this.isLoading = true;
          var id = localStorage.getItem('idcotizacion');
          axios.post(this.$rutaServer+'cosultarDocumentos', { idcotizacion: id })
            .then(response => {
              if (response.status == 200) {
                //this.formularios = response.data;
                /*var arregloLegal = new Array();
                var arregloInspector = new Array();
                var arregloCRE = new Array();
                var arregloAdministrador = new Array();*/

                response.data.forEach(ele => {
                    if(ele.tipo == 'Legal'){
                        var ruta = '';
                        if(ele.url_pdf > ' '){
                            const palabras = ele.url_pdf.split("/");
                            ruta = palabras[2];
                        }
                        var objeto = {
                            id:ele.id,
                            nombre :ele.nombre,
                            estatus:ele.estatus,
                            tipo:ele.tipo,
                            url_pdf: ruta,
                            url:this.$rutaImagenes+ele.url_pdf
                        };
                        this.arregloLegal.push(objeto);
                    }
                    if(ele.tipo == 'Inspector'){
                        var ruta = '';
                        if(ele.url_pdf > ' '){
                            const palabras = ele.url_pdf.split("/");
                            ruta = palabras[2];
                        }
                        var objeto = {
                            id:ele.id,
                            nombre :ele.nombre,
                            estatus:ele.estatus,
                            tipo:ele.tipo,
                            url_pdf: ruta,
                            url:this.$rutaImagenes+ele.url_pdf
                        };
                        this.arregloInspector.push(objeto);
                    }
                    if(ele.tipo == 'CRE'){
                        var ruta = '';
                        if(ele.url_pdf > ' '){
                            const palabras = ele.url_pdf.split("/");
                            ruta = palabras[2];
                        }
                        var objeto = {
                            id:ele.id,
                            nombre :ele.nombre,
                            estatus:ele.estatus,
                            tipo:ele.tipo,
                            url_pdf: ruta,
                            url:this.$rutaImagenes+ele.url_pdf
                        };
                        this.arregloCRE.push(objeto);
                    }
                    if(ele.tipo == 'Administrador'){
                        var ruta = '';
                        if(ele.url_pdf > ' '){
                            const palabras = ele.url_pdf.split("/");
                            ruta = palabras[2];
                        }
                        var objeto = {
                            id:ele.id,
                            nombre :ele.nombre,
                            estatus:ele.estatus,
                            tipo:ele.tipo,
                            url_pdf: ruta,
                            url:this.$rutaImagenes+ele.url_pdf
                        };
                        this.arregloAdministrador.push(objeto);
                    }
                })
                this.isLoading = false;
                //return this.formularios();
                
              }
            })
            .catch(error => {
              //Swal.fire('¡Error!', 'Ocurrió un error', 'error');
            });
        }
      }
    }
    </script>
    
    <style scoped>
    table {
      border-collapse: collapse;
      width: 100%;
    }
    
    table, th, td {
      border: 1px solid black;
    }
    
    th, td {
      padding: 8px;
      text-align: left;
    }
    .styled-list {
        list-style-type: none;
        padding: 0;
      }
      
      .list-item {
        margin: 0;
        padding: 5px 0;
      }
      
      .circle {
        display: inline-block;
        width: 10px;
        height: 10px;
        background-color: red;
        border-radius: 50%;
        margin-right: 10px;
      }
      
      .circlecolor {
        display: inline-block;
        width: 10px;
        height: 10px;
        background-color: green;
        border-radius: 50%;
        margin-right: 10px;
      }
    
  .styled-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .list-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  
  .circle {
    width: 12px;
    height: 12px;
    background-color: red;
    border-radius: 50%;
    margin-right: 10px;
  }
  
  .circlecolor {
    width: 12px;
    height: 12px;
    background-color: green;
    border-radius: 50%;
    margin-right: 10px;
  }
  </style>